import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// actions
import { change } from 'redux-form/immutable';

// components
import SchedulePeriod from './_SchedulePeriod';
import { Checkbox } from '../shared/_form';
import { Field } from 'redux-form/immutable';

class ScheduleSegment extends React.Component {
  static propTypes = {
    checkbox: PropTypes.bool,
    disabled:  PropTypes.bool,
    endTime:   PropTypes.number,
    form:      PropTypes.string,
    fromValue: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    hasError:  PropTypes.bool,
    label:     PropTypes.string.isRequired,
    name:      PropTypes.string.isRequired,
    onDisable: PropTypes.func,
    startTime: PropTypes.number,
    toValue:   PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ])
  }

    static defaultProps = {
      checkbox: true
    }

    componentWillMount() {
      const { disabled, form, fromValue, name, toValue, dispatch } = this.props;

      if (disabled && (fromValue || toValue)) {
        dispatch(change(form, `${name}.enabled`, true));
      }
    }

    render() {
      const { disabled, checkbox, label, name } = this.props;

      return (
        <div className={ classNames('schedule__period', { 'schedule__period--disabled': disabled }) }>
          { this._renderError() }
          <div className='schedule__period__label'>
            { checkbox && <Field component={ this._renderCheckbox }
              id={ `${name}.enabled` }
              name='enabled' />}
            <label htmlFor={ `${name}.enabled` }>{ label }</label>
          </div>
          <div className='schedule__period__input'>
            <div className='schedule__period__input__label'>from</div>
            <div className='schedule__period__input__field'>
              <Field component={ this._renderFrom }
                disabled={ disabled }
                name='from' />
            </div>
          </div>
          <div className='schedule__period__input'>
            <div className={ classNames('schedule__period__input__label schedule__period__input__to', { 'schedule__period__input__label--disabled': this._beginTime() === 0 }) }>to</div>
            <div className='schedule__period__input__field'>
              <Field component={ this._renderTo }
                disabled={ this._isToDisabled() }
                name='to' />
            </div>
          </div>
        </div>
      );
    }

  // private

  _renderCheckbox = this._renderCheckbox.bind(this);
  _renderFrom     = this._renderFrom.bind(this);
  _renderTo       = this._renderTo.bind(this);

  _beginTime() {
    const fromValue = this.props.fromValue;

    return fromValue && fromValue > 0 ? parseInt(fromValue, 10) + 900 : 0;
  }

  _handleDisable(input) {
    return (e) => {
      e.persist();

      const value = e.target.value === 'true';
      const { dispatch, form, name, onDisable } = this.props;

      if (value) {
        dispatch(change(form, `${name}.from`, null));
        dispatch(change(form, `${name}.to`, null));

        if (onDisable) onDisable(e);
      }

      input.onChange(e);
    };
  }

  _handleFromChange(input) {
    return (e) => {
      e.persist();

      input.onChange(e);

      setImmediate(() => {
        const { dispatch, form, name } = this.props;

        dispatch(change(form, `${name}.to`, null));
      });
    };
  }

  _isToDisabled() {
    let disabled = true;

    if (this._beginTime() > 0) {
      disabled = this.props.disabled;
    }

    return disabled;
  }

  _renderCheckbox({ input, meta, ...rest }) {
    const value = typeof input.value === 'boolean' ? input.value : false;

    return <Checkbox checked={ input.value }
      { ...input }
      { ...rest }
      onChange={ this._handleDisable(input) }
      value={ value } />;
  }

  _renderError() {
    let component;

    if (this.props.hasError) {
      component = <i className='fa fa-exclamation-circle schedule__period__error' />;
    }

    return component;
  }

  _renderFrom({ input, meta, ...rest }) {
    const { endTime, startTime } = this.props;

    return (
      <SchedulePeriod endTime={ endTime }
        startTime={ startTime }
        { ...input }
        { ...rest }
        onChange={ this._handleFromChange(input) } />
    );
  }

  _renderTo({ input, meta, ...rest }) {
    const { endTime, startTime } = this.props;

    return (
      <SchedulePeriod beginTime={ this._beginTime() }
        endTime={ endTime }
        startTime={ startTime }
        { ...input }
        { ...rest } />
    );
  }
}

export default connect()(ScheduleSegment);



// WEBPACK FOOTER //
// ./app/components/managers/_ScheduleSegment.jsx